<template>
    <div class="animated fadeIn h-100 admin-container">
        <div class="page-content">
            <div class="d-flex content-action align-items-center">
                <div class="input-group border-bottom position-relative" style="width: 190px">
                    <input
                        class="form-control bg-transparent border-none pr-4"
                        :placeholder="$t('common.search')"
                        aria-label="Search"
                        v-model="searchKeyword"
                        style="min-width: 190px"
                    />
                    <i
                        class="fa fa-search position-absolute"
                        style="top: 50%; right: 4px; margin-top: -6px"
                    />
                </div>
            </div>
            <b-table
                class="mt-2"
                striped
                hover
                :items="listAuditsDisplay"
                :fields="fields"
                show-empty
                :current-page="currentPage"
                :per-page="CONSTANTS.AUDIT_ITEM_PER_PAGE"
                :filter="searchKeyword"
                :filter-included-fields="['userId', 'content']"
                @filtered="onFiltered"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
            >
                <template v-slot:cell(index)="data">{{
                    (currentPage - 1) * CONSTANTS.AUDIT_ITEM_PER_PAGE + (data.index + 1)
                }}</template>
                <template v-slot:cell(createdAt)="data">
                    <span>{{ data.value | formatDateTime }}</span>
                </template>
                <template v-slot:empty>
                    <div class="text-center">
                        <span>Không tìm thấy bản ghi nào</span>
                    </div>
                </template>
            </b-table>
            <div v-if="totalRows > CONSTANTS.AUDIT_ITEM_PER_PAGE" class="my-1">
                <b-pagination
                    v-model="currentPage"
                    :total-rows="totalRows"
                    :per-page="CONSTANTS.AUDIT_ITEM_PER_PAGE"
                    :hide-goto-end-buttons="true"
                    :prev-text="$t('common.prevPage')"
                    :next-text="$t('common.nextPage')"
                    class="my-0"
                    align="center"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CONSTANTS from '@/constants';
export default {
    mounted: function () {
        this.$nextTick(function () {
            this.getAllAudits();
            this.getListUsers();
            this.totalRows = this.listAuditsDisplay.length;
        });
    },
    data: function () {
        return {
            sortBy: 'createdAt',
            sortDesc: true,
            fields: [
                { tdClass: 'align-middle', key: 'index', label: '#' },
                { tdClass: 'align-middle', key: 'userId', label: this.$i18n.t('common.name') },
                { tdClass: 'align-middle', key: 'content', label: 'Hành động' },
                {
                    tdClass: 'align-middle',
                    key: 'createdAt',
                    label: this.$i18n.t('common.lastCreated')
                }
            ],
            CONSTANTS,
            currentPage: 1,
            searchKeyword: null,
            totalRows: 1
        };
    },
    computed: {
        ...mapState({
            listAudits: (state) => state.user.listAudits,
            listUsers: (state) => state.user.users
        }),
        userName() {
            const user = {};
            this.listUsers.forEach((element) => {
                user[element.id] = element.name;
            });
            return user;
        },
        listAuditsDisplay() {
            let listData = this.listAudits;
            listData = listData.map((item) => {
                return {
                    ...item,
                    userId: this.userName[item.userId]
                };
            });
            return listData;
        }
    },
    methods: {
        ...mapActions({
            getAllAudits: 'user/getAllAudits',
            getListUsers: 'user/getListUsers'
        }),
        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
        }
    }
};
</script>
